<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">薪酬发放</li>
      <div
        v-html="buildMsg()"
        style="
          margin-right: 20px;
          max-width: 80%;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
        "
      ></div>
      <el-button
        type="primary"
        :icon="Money"
        link
        @click="onShouDong"
        v-if="$judge_auth('652')"
      >
        手动发放
      </el-button>
      <el-button
        type="warning"
        :icon="OfficeBuilding"
        link
        @click="onYinQi"
        v-if="$judge_auth('653')"
      >
        银企发放
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.status"
        arrName="salarypayment_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、单号、工资表单号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-date-picker
        v-model="state.params.month"
        type="month"
        format="YYYY年M月"
        value-format="YYYY-MM"
        placeholder="薪资所属期"
        style="width: 140px"
      />
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="发放日期"
          end-placeholder="发放日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态/发放单号" sortable="status" width="120">
          <template #default="{ row }">
            <c_tabgroup :value2="row.order_id">
              <template #top>
                <component
                  :is="$statusFormat2('salarypayment_status', row.status)"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="工资单号/名称"
          :formatter="
            (row) => $tab_GroupFormat(row.payroll_order_id, row.name || '')
          "
          min-width="220"
        >
        </el-table-column>
        <el-table-column
          label="所属客户/扣缴义务人"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.customer_name || '-',
                row.withholding_agent_name || ''
              )
          "
          min-width="220"
        />
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="pay_date"
          sortable="pay_date"
          label="约定发薪日期"
          :formatter="$tab_TextFormat"
          align="center"
          :min-width="120"
        >
          <template #default="{ row }">
            <text
              :style="{
                color:
                  row.status == 0 &&
                  $dayjs(row.pay_date + ' 00:00:00') > $dayjs()
                    ? '#f00'
                    : '',
              }"
              >{{ row.pay_date }}</text
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="payed_money"
          sortable="payed_money"
          label="已发放金额"
          :formatter="$tab_PriceFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="money"
          label="本次发放金额"
          :formatter="$tab_MoneyFormat"
          align="center"
          :min-width="160"
        />
        <el-table-column
          prop="employee_num"
          label="本次发放数量"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="payed_num"
          label="成功数"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="failure_num"
          label="失败数"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="interface_paying_num"
          label="银企发放中"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <!-- <el-table-column
          label="银企发放数量"
          min-width="160"
          sortable="interface_status"
          align="center"
        >
          <template #default="{ row }">
            <div v-if="row.interface_status == 0">-</div>
            <div v-else>
              <el-tag type="primary"
                >发放中：{{ row.interface_paying_num }}</el-tag
              >
              <el-tag type="success" style="margin: 5px 0"
                >成功数：{{ row.interface_payed_num }}</el-tag
              >
              <el-tag type="danger"
                >失败数：{{ row.interface_failure_num }}</el-tag
              >
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          :width="220"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              v-if="row.status === 0 && $judge_auth('132')"
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryPaymentDetail',
                  title: '薪资发放单',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              操作
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              v-else
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryPaymentDetail',
                  title: '薪资发放单',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
            <el-button
              type="primary"
              link
              icon="Money"
              v-if="row.status === 0 && $judge_auth('648')"
              @click="onPay(row)"
            >
              开始发放
            </el-button>
            <!-- <el-button
              type="warning"
              link
              icon="SwitchButton"
              v-if="row.status === 1 && $judge_auth('649')"
              @click="onBack(row)"
            >
              撤回发放
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showWithholdingAgent"
      title="选择扣缴义务人"
      @close="state.showWithholdingAgent = false"
    >
      <c_WithholdingAgentSelect
        @close="
          (arr) => {
            state.withholding_agent_arr = arr;
            state.showWithholdingAgent = false;
          }
        "
        :selectItems="state.withholding_agent_arr"
      ></c_WithholdingAgentSelect>
    </c_popup>
  </transition>
  <el-dialog
    v-model="state.showYinQi"
    title="银企发放"
    width="500px"
    align-center
  >
    <ul style="text-align: center; font-weight: 600; font-size: 140%">
      您本次共选择
      <text style="color: #1e90ff; font-size: 160%">{{ onSelectCount() }}</text
      >条发放单
    </ul>
    <ul style="display: flex; align-items: center; margin-top: 15px">
      <li style="white-space: nowrap">发放摘要：</li>
      <el-select
        v-model="state.furinfo"
        placeholder="请选择发放摘要"
        size="large"
      >
        <el-option
          v-for="item in state.bocfurinfo_data"
          :key="item"
          :value="item.value"
          :label="item.name"
        ></el-option>
        <template #footer>
          <el-button size="small" @click="onLoadBocFurInfo()">刷新</el-button>
        </template>
      </el-select>
    </ul>
    <ul style="text-align: right; margin-top: 40px">
      <el-button
        type="primary"
        @click="onSubmitYinQi"
        size="large"
        style="width: 100%"
      >
        提交
      </el-button>
    </ul>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  salarypayment_list,
  salarypayment_manualpay,
  salarypayment_b2epay,
  salarypayment_startpay,
  salarypayment_cancelpay,
} from "@/http/salarypayment";
import { data_b2edictionary_getbocfurinfo } from "@/http/data";
import { data_customer_select } from "@/http/data";
import { ElMessageBox, ElMessage } from "element-plus";
import { priceFormat, numberFormat } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "pay_date",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoad();
      onLoadBocFurInfo();
    });

    const onLoadBocFurInfo = () => {
      data_b2edictionary_getbocfurinfo().then((res) => {
        if (res.status == 200) {
          state.bocfurinfo_data = res.data.data;
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;

      salarypayment_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //手动发放
    const onShouDong = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择发放单",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否确认<strong style='color:#1e90ff'>手动发放</strong>？`,
        "手动发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定发放",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        salarypayment_manualpay({ id: rows.map((m) => m.id).join(",") }).then(
          (res) => {
            if (res.status == 200) {
              ElMessage.success(res.data.msg);
              onLoad();
            }
          }
        );
      });
    };

    const onSelectCount = () => {
      return tableDom.value.getSelectionRows()?.length || 0;
    };

    //银企发放
    const onYinQi = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择发放单",
          grouping: true,
        });
        return false;
      }
      state.showYinQi = true;
    };

    const onSubmitYinQi = () => {
      if (!state.furinfo) {
        ElMessage({
          type: "warning",
          message: "请选择发放摘要",
          grouping: true,
        });
        return false;
      }

      const rows = tableDom.value.getSelectionRows();
      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否确认<strong style='color:#ffa500'>调用银企发放</strong>？`,
        "银企发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定发放",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        salarypayment_b2epay({
          id: rows.map((m) => m.id).join(","),
          furinfo: state.furinfo,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //开始发放
    const onPay = (row) => {
      ElMessageBox.confirm(
        `您确定开始发放单号为<strong style='color:#1e90ff'>${row.order_id}</strong>的发放单吗？`,
        "开始发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定发放",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        salarypayment_startpay({ id: row.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //撤回发放
    const onBack = (row) => {
      ElMessageBox.confirm(
        `您确定撤回单号为<strong style='color:#f00'>${row.order_id}</strong>的发放单吗？`,
        "撤回发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定撤回",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        salarypayment_cancelpay({ id: row.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const buildMsg = () => {
      const rows = tableDom?.value?.getSelectionRows();
      let msg = "";

      if (rows?.length > 0) {
        const item = rows.reduce(
          (item, cur) => {
            item.employee_num += cur.employee_num;
            item.money += parseFloat(cur.money);
            return item;
          },
          {
            employee_num: 0,
            money: 0,
          }
        );

        msg += `已选：<text style='font-weight:600;color:#1e90ff'>${
          rows.length
        }</text>单，合计<text style='font-weight:600;color:#080'>${numberFormat(
          item.employee_num
        )}</text>笔，合计金额：<text style='font-weight:600;color:#f00'>￥${priceFormat(
          item.money
        )}</text>`;
      }

      return msg;
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onDateChange,
      tableDom,
      onRowClick,
      onShouDong,
      onYinQi,
      onSubmitYinQi,
      onPay,
      onBack,
      onSelectCount,
      onLoadBocFurInfo,
      buildMsg,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
